import { useLocaleState, useTranslate } from "react-admin";
import { SortableList } from "./SortableList";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { muiColors } from "themes/colors";

const MenuDndSectionItem = ({
  menu_section,
  serviceChoices,
  onChangeServices
}: any) => {
  const translate = useTranslate();
  const services = menu_section.menu_section_services || [];
  const [localeState] = useLocaleState();

  return (
    <div>
      <div className="text-[14px] text-[rgba(48,47,46,0.6)]">
        {translate("appointment.services")}::
      </div>
      <SortableList
        items={services}
        onChange={(newServices: any) =>
          onChangeServices(newServices, menu_section.id)
        }
        renderItem={(item: any, itemIndex: number | undefined) => (
          <SortableList.Item id={item.id}>
            <div className="w-full flex items-center justify-between">
              <div className="flex items-center">
                <SortableList.DragHandle />
                <div className="min-w-[24px] ml-2">
                  {itemIndex !== undefined && itemIndex + 1 + ". "}
                </div>
                {item?.name || item?.service?.name}
              </div>
              <IconButton
                sx={{
                  marginRight: "8px",
                  width: "32px",
                  height: "32px"
                }}
                onClick={() => {
                  const updated = services.filter((i: any) => i.id !== item.id);
                  onChangeServices(updated, menu_section.id);
                }}
              >
                <CloseIcon
                  sx={{
                    width: "24px",
                    height: "24px",
                    color: muiColors.error
                  }}
                />
              </IconButton>
            </div>
          </SortableList.Item>
        )}
      />
      <div>
        <FormControl fullWidth sx={{ marginTop: "16px" }}>
          <InputLabel
            id="dnd-add-services-custom-select"
            sx={{
              color: "#B8722A !important",
              fontFamily: "Inter",
              fontSize: "14px !important",
              fontWeight: 500,
              transform: "translate(12px, 8px) scale(1)",
              "&.Mui-focused": {
                color: "#B8722A !important"
              }
            }}
          >
            {translate("order.add_service")}
          </InputLabel>
          <Select
            labelId="dnd-services-custom-select"
            id="dnd-services-custom-select"
            variant="filled"
            value=""
            onChange={(event) => {
              const newService = event.target.value;
              const updated = [...services, newService];
              onChangeServices(updated, menu_section.id);
            }}
            sx={{
              maxWidth: localeState === "vi" ? "116px" : "104px",
              height: "36px",
              width: "100%",
              backgroundColor: "#fff",
              borderRadius: "18px !important",
              borderColor: "#B8722A !important",
              "& .MuiFilledInput-input": {
                paddingTop: "6px",
                paddingBottom: "6px",
                fontWeight: 400
              },
              "&:hover": {
                backgroundColor: "#fff"
              },
              "&.Mui-focused": {
                backgroundColor: "#fff !important"
              },
              "&:after": {
                borderRadius: "18px !important",
                borderColor: "#B8722A !important"
              },
              "& .MuiFilledInput-root:after": {
                borderRadius: "18px !important",
                borderColor: "#B8722A !important"
              },
              "& .MuiSelect-icon": {
                display: "none"
              }
            }}
            renderValue={(value: any) => {
              return <span>{value?.name}</span>;
            }}
          >
            {serviceChoices
              ?.filter(
                (service: any) =>
                  !services.some((item: any) => item.id === service.id)
              )
              ?.map((item: any) => (
                <MenuItem key={item?.id} value={item}>
                  {item?.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default MenuDndSectionItem;
